import { apiClient } from '@/libs/axios';

export const logout = async (): Promise<void> => {
  await apiClient.post('auth/logout');
};
